<main>
  <h1 mat-dialog-title>{{'CancelAppointment' | translate}}</h1>
 
  <section class="loading-container" *ngIf="isDeleting">
    <div  class="pulsing" >
      <mat-spinner [diameter]="50" ></mat-spinner>
    </div>
    <p class="pulsing" >{{ "Loading" | translate }}...</p>
  </section>

  <section class="cancel_appointment_dialog__hours" *ngIf="!isDeleting">
    <div mat-dialog-content>
      <p class="delete-dialog-content">
        {{deleteAppointmentPreventiveMessage}}
        <strong>{{typeOfService}},</strong>
        {{deleteAppointmentPreventiveMessageTwo}}
        <strong>{{appointmentSchedule}},</strong>
        {{deleteAppointmentPreventiveMessageThree}}
      </p>
    </div>
  </section>

  <mat-dialog-actions align="center">
    <button mat-dialog-close class="dialog__button" *ngIf="!isDeleting">
      {{"Cancel" | translate}}
    </button>
    <button
      *ngIf="!isDeleting"
      class="dialog__button dialog__button--fill"
      (click)="DeleteSchedule()"
    >
      {{"Accept" | translate}}
    </button>
  </mat-dialog-actions>
</main>
